import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/Layout";
import styles from './LandingPage.module.css';
import RequestList from "../../components/requests/RequestList";
import { connect } from "react-redux";
import StoreroomRequestList from "../../components/requests/StoreroomRequestList";

const LandingPage = ({ user }) => {
    localStorage.removeItem('idPedido');
    const [userTypeClass, setUserTypeClass] = useState(null);

    useEffect(() => {
        if (user) {
            const userType = user.tipo === 'profesor' ? styles.teacher : styles.storeroom;
            setUserTypeClass(userType);
        }
    }, [user]);

    if (!user) {
        return (
            <Layout>
                <main className="loading">
                    <p>Loading user information...</p>
                </main>
            </Layout>
        );
    }

    return (
        <Layout>
            <main className={`${userTypeClass}`}>
                {user.tipo === 'profesor' ? (
                    <RequestList />
                ) : (
                    <StoreroomRequestList />
                )}
            </main>
        </Layout>
    );
};

const mapStateToProps = state => ({
    isAuthenticated: state.Auth.isAuthenticated,
    user: state.Auth.user,
});

export default connect(mapStateToProps, {})(LandingPage);
